
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import FooterReducer from './Reducers/FooterReducer';
import APIErrorReducer from './Reducers/APIErrorReducer';
import UserSlice, { isLoggedIn } from '../Utils/UserSlice';
import darkModeReducer from './Reducers/ThemeReducer';
import storage from 'redux-persist/lib/storage';
import persistReducer from 'redux-persist/es/persistReducer';
import persistStore from 'redux-persist/es/persistStore';
import themeReducer from './Reducers/ColorTheme';


const persistConfig = {
  key: 'root', // Key for localStorage (you can use a more specific key)
  storage, // Storage method (can use other storage methods too)
  whitelist: ['user', 'darkMode', 'ThemeChange'], // Reducers to persist (only persist 'user' here)
};


const rootReducer = combineReducers({
  error:APIErrorReducer,
  footer: FooterReducer,
  user: UserSlice,
  darkMode: darkModeReducer,
  ThemeChange:themeReducer,
});

// const store = configureStore({
//   reducer: {
//     error:APIErrorReducer,
//     footer: FooterReducer,
//     user: UserSlice,
//     darkMode: darkModeReducer,
//   },
// });

const persistedReducer = persistReducer(persistConfig, rootReducer);

// 4. Set up the Redux store with persisted reducer
const store = configureStore({
  reducer: persistedReducer,
});

// 5. Create a persistor for the store
const persistor = persistStore(store);

export { store, persistor };

// export default store;



